import { StepIds } from '../models/property-step/property-step-model';
import {
    StepDisabledStates,
    StepModel,
    StepTouchedStates,
    StepValidityStates,
    StepVisibilityStates
} from '@classifieds-sell/shared';

export const PROPERTY_DEFAULT_STEP_STRUCTURE = [
    new StepModel(
        StepIds.propertyInformation,
        'Property information',
        StepDisabledStates.enabled,
        StepValidityStates.invalid,
        StepTouchedStates.untouched,
        StepVisibilityStates.visible
    ),
    new StepModel(
        StepIds.propertyDescription,
        'Property description',
        StepDisabledStates.disabled,
        StepValidityStates.invalid,
        StepTouchedStates.untouched,
        StepVisibilityStates.visible
    ),
    new StepModel(
        StepIds.propertyPhotos,
        'Photos & media',
        StepDisabledStates.disabled,
        StepValidityStates.invalid,
        StepTouchedStates.untouched,
        StepVisibilityStates.visible
    ),
    new StepModel(
        StepIds.propertyPromote,
        'Promote',
        StepDisabledStates.disabled,
        StepValidityStates.invalid,
        StepTouchedStates.untouched,
        StepVisibilityStates.visible
    ),
    new StepModel(
        StepIds.propertySummary,
        'Summary',
        StepDisabledStates.disabled,
        StepValidityStates.invalid,
        StepTouchedStates.untouched,
        StepVisibilityStates.visible
    )
];
